/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Edit_Items_Locked_NoticeInputs */

const vi_order_edit_items_locked_notice = /** @type {(inputs: Order_Edit_Items_Locked_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn đã qua bước xác nhận nên không sửa được sản phẩm/vật tư. Chỉ có thể sửa thông tin khách hàng và giao hàng.`)
};

/**

* @param {Order_Edit_Items_Locked_NoticeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_edit_items_locked_notice = /** @type {((inputs?: Order_Edit_Items_Locked_NoticeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Edit_Items_Locked_NoticeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_edit_items_locked_notice(inputs)
});